import React from 'react';

import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material';
import MuiEditIcon from '@mui/icons-material/Edit';
import MuiPrintIcon from '@mui/icons-material/Print';
import MuiSendIcon from '@mui/icons-material/Send';

const SpacerBottom = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(3),
}));

const ContainerGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '50px 30px 50px auto 50px 30px 50px auto 50px 30px 50px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '30px 30px 30px auto 30px 30px 30px auto 30px 30px 30px',
  },
  textAlign: 'center',
  alignItems: 'center',
  rowGap: '10px',
  fontSize: '14px',
}));

const RoundedBackground = styled('div')<{ marked: number }>(({ marked, theme }) => ({
  display: 'flex',
  backgroundColor: marked ? theme.palette.text.primary : theme.palette.text.disabled,
  borderRadius: '15px',
  width: '30px',
  height: '30px',
  justifyContent: 'center',
  alignItems: 'center',
}));

const howToIcon = (component: any) =>
  styled(component)(({ theme }: { theme: Theme }) => ({
    color: theme.palette.secondary.contrastText,
    fontSize: '16px',
  }));

export const EnterDataIcon = howToIcon(MuiEditIcon);
export const PrintIcon = howToIcon(MuiPrintIcon);
export const SendIcon = howToIcon(MuiSendIcon);

const Divider = styled('div')(({ theme }) => ({
  height: '1px',
  border: `solid 1px ${theme.palette.grey[600]}`,
  marginLeft: '10px',
  marginRight: '10px',
}));

interface Props {
  testId?: string;
  completedSteps: string[];
}

export const CashbackProcessFlow = ({ completedSteps }: Props) => {
  const { t } = useTranslation();

  return (
    <SpacerBottom>
      <ContainerGrid>
        <div></div>
        <RoundedBackground marked={completedSteps?.includes('enterData') ? 1 : 0}>
          <EnterDataIcon />
        </RoundedBackground>
        <Divider style={{ gridColumnStart: 3, gridColumnEnd: 6 }} />
        <div>
          <RoundedBackground marked={completedSteps?.includes('print') ? 1 : 0}>
            <PrintIcon />
          </RoundedBackground>
        </div>
        <Divider style={{ gridColumnStart: 7, gridColumnEnd: 10 }} />
        <div>
          <RoundedBackground marked={completedSteps?.includes('send') ? 1 : 0}>
            <SendIcon />
          </RoundedBackground>
        </div>
        <div></div>

        <div style={{ gridColumnStart: 1, gridColumnEnd: 4 }}>
          {t('cashbackProcessIntroduction.enterData')}
        </div>
        <div></div>
        <div style={{ gridColumnStart: 5, gridColumnEnd: 8 }}>
          {t('cashbackProcessIntroduction.print')}
        </div>
        <div></div>
        <div style={{ gridColumnStart: 9, gridColumnEnd: 12 }}>
          {t('cashbackProcessIntroduction.sendToUs')}
        </div>
      </ContainerGrid>
    </SpacerBottom>
  );
};
